import './style/index.less'

import $ from 'jquery';
import './js/city-select';
import inputSearch from './js/input-search'
import adQrcode from './js/ad-qrcode'
import cityChang from './js/city-change'
import hotSearch from './js/hot-search'
import lxWrap from '../common/js/lx'
import lxBid from '../common/js/lx-bid'
import cityChange from './js/city-change';


/**
 * 获得 keyword
 */
function getKeyWords() { 
    let keyword = ''
    let pathArray = location.pathname.split('/')
    if (location.pathname.indexOf('/search/keyword/') !== -1) { 
        if (pathArray.length > 0) { 
            let lastPath = pathArray[pathArray.length - 1]
            let keywordArray = lastPath.split('_')
            if (keywordArray.length > 1) {
                keyword = decodeURIComponent(keywordArray[keywordArray.length - 1])
            }
        }
       
    }
    
    return keyword
}

/**
 * 设置keyword
 * @param {*} node 
 * @param {*} keyword 
 */
function setKeyWords(node, value) {
    node.val(value)
}


/**
 * 首页导航中间logo和input框
 */
export default {
    init: (config) => {

        // console.log('logo-input');
        // 城市选择

        const container = $('#logo-input');
        let $inputNode = container.find('#J-search-input')
        let keyword = getKeyWords()

        if (keyword.length > 0 && $inputNode.length > 0) { 
            setKeyWords($inputNode, keyword)
        }

        container.cityselect({
            'triggleEle': '.J-city',
            'targetEle': '.J-city-list',
            'activeClass': 'city-active',
            'hideClass': 'Hide'
        });

        
        // 初始化搜索框
        if (config.isOtherPage) { // 霸王餐 社区
            const basicSearch = require('../logo-input/js/basic-search')
            basicSearch.default.init({
                'container': $('#logo-input'),
                'domain': config.domain || '',
                'cityId': config.cityId,
                'searchUrl': config.sdomain + '/search/1_'
            })
        } else {
            inputSearch.init({
                'container': $('#logo-input'),
                'domain': config.domain || '',
                'cityId': config.cityId,
                'channelId': config.channelId
            });
            let hotSearchPanel = $('#logo-input .J-hot-search')
            if (hotSearchPanel.length > 0) { 
                let hotWordsConfig = config;
                hotWordsConfig.container = container;
                hotWordsConfig.SHOW_NUM = 6;
        
                hotSearch.init(hotWordsConfig)
            }
            
        }

        // 右侧二维码
        adQrcode.init(container)
        
        // 城市选择
        cityChange.init(container)



        // web4.0 灵犀打点
        // logo
        lxWrap($('#logo-input .logo'), lxBid.logoBid, false, false, true, true)
        // 搜索框点击
        lxWrap($('#J-search-input'), lxBid.inputSearchBid, false, false, false)
        lxWrap($('#J-all-btn'), lxBid.searchBntBid, false, false)
        // 城市列表
        lxWrap($('.J-city'), lxBid.cityBid, false, false)
    }
}



// WEBPACK FOOTER //
// ./modules/logo-input/index.js